import { isEqual } from 'lodash';
import React, { useState } from 'react';
import { DeviceOs as DeviceOsBidderType } from 'sonata-static-storage/lib/common/common.types';

import { fetchDeviceOs } from '@/resources/devices.resources';
import { Os } from './Os';

import type { DevicePlatformInterface } from 'sonata-static-storage/lib/schemas/campaign/targeting/devicePlatform.schema';
import type { DeviceOsType } from 'sonata-static-storage/lib/schemas/targeting/DeviceOs/DeviceOs.types';

type Props = Omit<React.ComponentProps<typeof Os>, 'getDeviceOs' | 'onDeviceOsChanged'> & {
  deviceTypes: DevicePlatformInterface[];
  onDeviceOsChanged: (devicesOs: DeviceOsType[]) => void;
};

function OsMultiflightWrapper(props: Props) {
  const { deviceTypes, onDeviceOsChanged, selectedDeviceOs } = props;
  const [devices, setDevices] = useState<DeviceOsType[]>(selectedDeviceOs);

  const token = {};

  const requestDeviceTypes = deviceTypes.filter(dt => dt.enable).map(dt => dt.name);

  const handleDeviceOsOnChanged = (newDevices: DeviceOsBidderType[]) => {
    const targetingDeviceOs = newDevices.map(({ os }) => os);
    if (isEqual(devices, targetingDeviceOs)) {
      return;
    }
    setDevices(targetingDeviceOs);
    onDeviceOsChanged(targetingDeviceOs);
  };

  return (
    <Os
      {...props}
      getDeviceOs={() => fetchDeviceOs(requestDeviceTypes, token)}
      onDeviceOsChanged={handleDeviceOsOnChanged}
    />
  );
}

OsMultiflightWrapper.displayName = OsMultiflightWrapper.name;
export default OsMultiflightWrapper;
